import { BASIC_FONT_SIZE } from '../consts/style-consts';

const pxToRem = (pxValue) => `${pxValue / BASIC_FONT_SIZE}rem`;

export default pxToRem;
